(function () {
    'use strict';

    angular.module('app')
        .factory('ObraMuseo', Service);

    /* @ngInject */
    function Service(ResourceHelper) {
        var entidad = "obra-museo";
        return ResourceHelper.getResource(entidad, {}, {
            bajar: {
                method: 'GET',
                url: 'api/' + entidad + '/bajar',
                params: {
                    id: null
                }
            },
            subir: {
                method: 'GET',
                url: 'api/' + entidad + '/subir',
                params: {
                    id: null
                }
            },
            findBySala: {
                method: 'GET',
                url: 'api/' + entidad + '/findBySala',
                params: {
                    id: null
                },
                isArray: true
            }
        });
    }

})();
